import React, { useEffect } from 'react';
import MicroseismicAddPhoto from '../images/MicroseismicAdd.png';
import MicroseismicEditPhoto from '../images/MicroseismicEdit.png';
import MicroseismicRemoveOnePhoto from '../images/MicroseismicRemoveOne.png';
import MicroseismicRemoveAllPhoto from '../images/MicroseismicRemoveAll.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const SeismicEventPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Microseismic Events
        </div>
        <div style={{ margin: '10px 0px' }}>
        To add Microseismic, right click <strong>Project</strong> node, then click <strong>Add Microseismic Events</strong> menu. In <strong>Add Microseismic Events</strong> dialog, 
        enter Name, Color, and Events, then click <strong>OK</strong>.
        </div>
        <div style={{ margin: '10px 0px' }}>
        Events' data format is Latitude, Logitude, Elevation, Time, Magitude, and Confidence. Time is the milli sesconds from 1970, Jan 1 to the event's time. Each Microseismic Event is in a line. 
        </div>

        <StyledContainer>
            <img src={MicroseismicAddPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To edit Microseismic Events, right click Microseismic Events node you want to edit, then click <strong>Edit This Seismic Events</strong> menu.
        </div>

        <StyledContainer>
            <img src={MicroseismicEditPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove Microseismic Events, right click Microseismic Events node you want to remove, then click <strong>Remove These Seismic Events</strong> menu.
        </div>
        <StyledContainer>
            <img src={MicroseismicRemoveOnePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove all of Microseismic Events, right click <strong>Seismic Events</strong> node, then click <strong>Remove All Seismic Eventss</strong> menu.
        </div>
        <StyledContainer>
            <img src={MicroseismicRemoveAllPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default SeismicEventPage;